export default __webpack_public_path__ + "static/media/aws-route53.7a525408.svg";